import React from 'react';

import { Dialog } from '../../../base/dialog';
import { translate } from '../../../base/i18n';
import { connect } from '../../../base/redux';
import { setPrivateChatDisabledAndBroadcast } from '../../actions.web';

type Props = {
    dispatch: Function,
    t: Function,
    isPrivateChatDisabled: boolean
};

/**
 * Component for confirming the action of disabling private chat.
 *
 * @param {*} props - The props of the component.
 * @param {*} param0 - The props of the component.
 * @returns {React$Element<any>}
 */
function DisablePrivateChatDialog({ dispatch, t, isPrivateChatDisabled }: Props) {
    const onSubmit = () => {
        dispatch(setPrivateChatDisabledAndBroadcast(!isPrivateChatDisabled));

        return true;
    };

    return (
        <Dialog
            okKey = { 'dialog.Yes' }
            onSubmit = { onSubmit }
            titleString = { isPrivateChatDisabled ? t('chat.enablePrivateChat') : t('chat.disablePrivateChat') }
            width = 'small'>
            <div>
                { isPrivateChatDisabled
                    ? t('chat.enablePrivateChatConfirmation')
                    : t('chat.disablePrivateChatConfirmation') }
            </div>
        </Dialog>
    );
}

const mapStateToProps = state => {
    return {
        isPrivateChatDisabled: state['features/chat']?.isPrivateChatDisabled || false
    };
};

export default translate(connect(mapStateToProps)(DisablePrivateChatDialog));
